var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
var PercentageComponent = function (props) {
    var percent = {
        current: props.current,
        total: props.total,
    };
    return (_jsxs("p", __assign({ className: "percentage-container" }, { children: [Math.round((100 * (percent.current + 1)) / percent.total), "% complete"] }), void 0));
};
export default PercentageComponent;
